export const AJOUTE_URL_CLIENT = "AJOUTE_URL_CLIENT";
export const SUPRIMER_URL_CLIENT = "SUPRIMER_URL_CLIENT";